import styled from "styled-components";

const ListUnstyled = styled.ol`
  list-style-type: none;
  margin: 0;
  padding: 0;
`;

export default ListUnstyled;
